import { render, staticRenderFns } from "./HistoricItem.vue?vue&type=template&id=8de13802&scoped=true&"
import script from "./HistoricItem.vue?vue&type=script&lang=js&"
export * from "./HistoricItem.vue?vue&type=script&lang=js&"
import style0 from "./HistoricItem.vue?vue&type=style&index=0&id=8de13802&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8de13802",
  null
  
)

export default component.exports